module.exports = __webpack_public_path__ + "static/media/willy-wo-pXnMG0FfSwA-unsplash.4e0d811e.jpg";